<div class="flow-success-container">
  <div>
    <img class="flow-success-container-thrash_icon" src='../../../../../../assets/svg/redesign/Delete_Thrash.svg' />
    <img
      class="flow-success-container-check_icon"
      src='../../../../../../assets/svg/redesign/Check_Mark_Filled.svg'
    />
  </div>

  <div class="flow-success-container-description">
    Flow “{{ flowName }}” has been successfully deleted.
  </div>
  <div class="flow-success-container-newFlow" (click)="toNewFlow()">
    <img class="flow-success-container-newFlow-icon" src='../../../../../../assets/svg/redesign/add.svg' />
    <span class="flow-success-container-newFlow-text">Create New Flow</span>
  </div>
</div>
